// src/theme/theme.ts
export const lightTheme = {
    primary: '#3498db', 
    secondary: '#2ecc71', 
    background: '#ecf0f1', 
    text: '#2c3e50', 
  };
  
  export const darkTheme = {
    primary: '#9b59b6', 
    secondary: '#e74c3c', 
    background: '#2c3e50', 
    text: '#ecf0f1',
  };
  